/* eslint
    no-return-assign: "warn",
    no-sequences: "warn",
    @typescript-eslint/no-shadow: "warn",
    prefer-const: "warn",
    no-prototype-builtins: "warn",
    prefer-template: "warn",
    @typescript-eslint/no-use-before-define: "warn",
    no-unused-expressions: "warn",
    no-promise-executor-return: "warn",
    arrow-body-style: "warn",
    no-unneeded-ternary: "warn",
    no-useless-return: "warn"
*/

import { element, elements } from './easyfy.core';

export interface Attribute {
  name: string;
  value: string;
}

// example
// findKey(
//   {
//     barney: { age: 36, active: true },
//     fred: { age: 40, active: false },
//     pebbles: { age: 1, active: true }
//   },
//   o => o['active']
// ); // 'barney
export const findKey = (obj: any, fn: any) => Object.keys(obj).find((key) => fn(obj[key], key, obj));

// example
// findLast([1, 2, 3, 4], n => n % 2 === 1); // 3
export const findLast = (arr: Array<any>, fn: any) => arr.filter(fn).pop();

// example
// all([4, 2, 3], x => x > 1); // true
// all([1, 2, 3]); // true
export const all = (arr: Array<any>, fn = Boolean) => arr.every(fn);

// example
// allEqual([1, 2, 3, 4, 5, 6]); // false
// allEqual([1, 1, 1, 1]); // true
export const allEqual = (arr: Array<any>) => arr.every((val) => val === arr[0]);

// example
// arrayToHtmlList('#myListID', 'li' ,['item 1', 'item 2']);
// TODO: Probably dead code. Also, it's broken.
export const arrayToHtmlList = (selector: string, elementType: string, arr: Array<any>) => { ((el) => ((el = document.querySelector(selector)), (el.innerHTML += arr.map((item) => `<${elementType}>${item}</${elementType}>`).join(''))))(); };

// example
// hasClass(document.querySelector('p.special'), 'special'); // true
export const hasClass = (el: HTMLElement, className: string) => el?.classList?.contains(className);

// example
// isBrowserTabFocused(); // true
export const isBrowserTabFocused = () => !document.hidden;

// example
// isNil(null); // true
// isNil(undefined); // true
export const isNil = (val: any) => val === undefined || val === null;

// example
// isNull(null); // true
export const isNull = (val: any) => val === null;

// example
// isNumber('1'); // false
// isNumber(1); // true
function isNumber(n: any) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

// example
// isObject([1, 2, 3, 4]); // true
// isObject([]); // true
// isObject(['Hello!']); // true
// isObject({ a: 1 }); // true
// isObject({}); // true
// isObject(true); // false
export const isObject = (obj: any) => obj === Object(obj);

// example
// isObjectLike({}); // true
// isObjectLike([1, 2, 3]); // true
// isObjectLike(x => x); // false
// isObjectLike(null); // false
export const isObjectLike = (val: any) => val !== null && typeof val === 'object';

// example
// isPlainObject({ a: 1 }); // true
// isPlainObject(new Map()); // false
// export const isPlainObject = (val: any) =>
//   !!val && typeof val === "object" && val.export && constructor === Object;

// example
// isString('10'); // true
export const isString = (val: any) => typeof val === 'string';

// example
// isUndefined(undefined); // true
export const isUndefined = (val: any) => val === undefined;

// example
// parse string into boolean
export const parseToBoolean = (val: string) => isString(val) && val?.toLowerCase() === 'true';

// example
// isValidJSON('{"name":"Adam","age":20}'); // true
// isValidJSON('{"name":"Adam",age:"20"}'); // false
// isValidJSON(null); // true
export const isValidJSON = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const replaceHtml = (targetElement: HTMLElement, html: string) => {
  if (targetElement?.outerHTML) {
    targetElement.outerHTML = html;
  }
  else {
    const tmpElement = document.createElement("div");
    tmpElement.innerHTML = html;
    targetElement?.parentNode?.replaceChild(tmpElement, targetElement);
  }
};

// example
// matches({ age: 25, hair: 'long', beard: true }, { hair: 'long', beard: true }); // true
// matches({ hair: 'long', beard: true }, { age: 25, hair: 'long', beard: true }); // false
export const matches = (obj: any, source: any) => Object.keys(source).every((key) => obj.hasOwnProperty(key) && obj[key] === source[key]);

// example
// randomHexColorCode(); // "#e34155"
export const randomHexColorCode = () => {
  const n = (Math.random() * 0xfffff * 1000000).toString(16);
  // return '#' + n.slice(0, 6);
  return `#${n.slice(0, 6)}`;
};

// example
// redirect('https://google.com');
export const redirect = (url, asLink = true) => (asLink ? (window.location.href = url) : window.location.replace(url));

// example
// scrollToTop();
export const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

// example
// setStyle('p', 'font-size', '20px');
export const setStyle = (selector: string, ruleName: string, val: string) => (element(selector).style[ruleName] = val);

// example
// getStyle('p', 'font-size');
export const getStyle = (selector: string, ruleName: string) => element(selector).style[ruleName];

// example
// show(...document.querySelectorAll("img")); // Shows all <img> elements on the page
export const showAll = (el: Array<HTMLElement>, displayType?: string) => {
  try {
    [...el].forEach((e) => {
      e.hidden = false;
      e.style.display = displayType || 'block';
    });
  } catch (error) {
    console.error(error);
  }
};

// example
// hide(document.querySelectorAll('img')); // Hides all <img> elements on the page
export const hideAll = (el: Array<HTMLElement> | NodeListOf<HTMLElement>) => {
  if (!el) {
    return;
  }

  el.forEach((elem) => {
    elem.style.display = 'none';
  });
};

export const show = (selector: string | Element, displayType?: string) => {
  try {
    showAll([selector instanceof Element ? selector : element(selector)], displayType);
  } catch (error) {
    console.error(error);
  }
};

export const hide = (selector: string | Element) => {
  try {
    const el = (selector instanceof Element ? selector : element(selector)) as HTMLElement | null;
    if (!el) {
      return;
    }

    // Find triggers linked to this element
    const id = el.id || '';
    if (id) {
      const triggers = document.querySelectorAll<HTMLElement>(
        `[aria-controls="${id}"], [data-dialog-open="${id}"], [data-target="${id}"]`
      );
      triggers.forEach(t => {
        if (t.hasAttribute('aria-expanded')) {
          t.setAttribute('aria-expanded', 'false');
        }
        if (el instanceof HTMLDialogElement) {
          if (t.getAttribute('aria-haspopup') !== 'dialog') {
            t.setAttribute('aria-haspopup', 'dialog');
          }
          if (!t.hasAttribute('aria-controls')) {
            t.setAttribute('aria-controls', id);
          }
        }
      });
    }

    // Prefer semantic closing where possible
    if (el instanceof HTMLDialogElement) {
      if (el.open) {
        el.close();
      }

      return;
    }

    if (el.hasAttribute('popover')) {
      (el as any).hidePopover?.();
      return;
    }

    // Disclosure/default: mark hidden and keep legacy visual hide
    el.hidden = true;
    hideAll([selector instanceof Element ? selector : element(selector)]);
  } catch (error) {
    console.error(error);
  }
};

export const toggleShow = (selector: string, displayType?: string) => {
  try {
    const el = element(selector);
    visible(el) ? hideAll([el]) : showAll([el], displayType);
  } catch (error) {
    console.error(error);
  }
};

export const removeCss = (el: HTMLElement | Element | Array<HTMLElement> | NodeListOf<HTMLElement>, className: string | Array<string>) => {
  if (Array.isArray(el) || el instanceof NodeList) {
    el.forEach((targetElement) => {
      Array.isArray(className) ? targetElement?.classList?.remove(...className) : targetElement?.classList?.remove(className);
    });
  } else {
    Array.isArray(className) ? (el as HTMLElement | Element)?.classList?.remove(...className) : (el as HTMLElement | Element)?.classList?.remove(className);
  }
};

export const addCss = (el: HTMLElement | Element, className: string | Array<string>) => {
  if (Array.isArray(className)) {
    el?.classList?.add(...className);
    return el;
  }

  el?.classList?.add(className);
  return el;
};

// example
// async function sleepyWork() {
//   console.log("I'm going to sleep for 1 second.");
//   await sleep(1000);
//   console.log('I woke up after 1 second.');
// }
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const visible = (targetElement: HTMLElement): boolean => !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length);

// example
// smoothScroll('#fooBar'); // scrolls smoothly to the element with the id fooBar
// smoothScroll('.fooBar'); // scrolls smoothly to the first element with a class of fooBar
export const smoothScroll = (targetElement: any) =>
  document.querySelector(targetElement).scrollIntoView({
    behavior: 'smooth',
  });

// example
// splitLines('This\nis a\nmultiline\nstring.\n'); // ['This', 'is a', 'multiline', 'string.' , '']
export const splitLines = (str: string) => str.split(/\r?\n/);

// example
// stripHTMLTags('<p><em>lorem</em> <strong>ipsum</strong></p>'); // 'lorem ipsum'
export const stripHTMLTags = (str: string) => str.replace(/<[^>]*>/g, '');

// example
// sum(1, 2, 3, 4); // 10
// sum(...[1, 2, 3, 4]); // 10
export const sum = (...arr: any) => [...arr].reduce((acc, val) => acc + val, 0);

// example
// timeTaken(() => Math.pow(2, 10)); // 1024, (logged): timeTaken: 0.02099609375ms
export const timeTaken = (callback: any) => {
  console.time("timeTaken");
  const r = callback();
  console.timeEnd("timeTaken");
  return r;
};

// example
// toCurrency(123456.789, "EUR"); // €123,456.79  | currency: Euro | currencyLangFormat: Local
// toCurrency(123456.789, 'USD', 'en-us'); // $123,456.79  | currency: US Dollar | currencyLangFormat: English (United States)
// toCurrency(123456.789, 'USD', 'fa'); // ۱۲۳٬۴۵۶٫۷۹ ؜$ | currency: US Dollar | currencyLangFormat: Farsi
// toCurrency(322342436423.2435, 'JPY'); // ¥322,342,436,423 | currency: Japanese Yen | currencyLangFormat: Local
// toCurrency(322342436423.2435, 'JPY', 'fi'); // 322 342 436 423 ¥ | currency: Japanese Yen | currencyLangFormat: Finnish
export const toCurrency = (n: any, curr: any, languageFormat = undefined) =>
  Intl.NumberFormat(languageFormat, {
    style: 'currency',
    currency: curr,
  }).format(n);

// example
// toDecimalMark(12305030388.9087); // "12,305,030,388.909"
// toDecimalMark(12305030388.9087, "en-us"); // "12,305,030,388.909"
export const toDecimalMark = (num: any, languageFormat = undefined) => num.toLocaleString(languageFormat);

// example
// toggleClass('p.special', 'special'); // The paragraph will not have the 'special' class anymore
export const toggleClass = (selector: string | HTMLElement, className: any, force?: boolean) => {
  // if (selector instanceof String) easyfyCore.element(selector as string).classList.toggle(className);

  if (selector instanceof HTMLElement) selector.classList.toggle(className, force);
};

export const debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number) => {
  let timeout;

  return (...args: Parameters<F>): Promise<ReturnType<F>> =>
    new Promise((resolve) => {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => resolve(func(...args)), waitFor);
    });
};

export const isFunction = (f: Function) => f && {}.toString.call(f) === '[object Function]';

export const Id = (len: number) => `_${Math.random().toString(36).substr(2, len)}`;

export const toggleClassBySelector = (selector: string, className: string, toggle: boolean) => {
  const els = elements(selector);
  els.forEach((item) => {
    if (toggle) {
      addCss(item, className);
    } else {
      removeCss(item, className);
    }
  });
};

export const setAttributes = (targetElement: HTMLElement, attributes: Array<Attribute>): HTMLElement | Element => {
  attributes.forEach((item) => {
    if (item?.name && item?.value) {
      targetElement.setAttribute(item.name, item.value);
    }
  });
  return targetElement;
};

export const offset = (targetElement: HTMLElement): { top: number; left: number; } => {
  const rect = targetElement.getBoundingClientRect();
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

export const winHeight = () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
export const winWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
export const isMobile = () => window.innerWidth <= 768;

export const isBetweenDates = (startDate: Date, endDate: Date, checkDate: Date) => {
  if (checkDate > startDate && checkDate < endDate) {
    return true;
  }
  return false;
};

// todo: support other short date string formats other then 2020-01-01
export const getDate = (date: string) => {
  if (date !== "") {
    const d = date.split("-");
    if (d.length === 3) {
      return new Date(parseInt(d[0], 10), parseInt(d[1], 10) - 1, parseInt(d[2], 10));
    }
  }
  return new Date();
};
export const getSelectedValue = (select: HTMLSelectElement) => {
  if (select) {
    const selectedOption = select.options[select.selectedIndex];
    return { text: selectedOption.text, value: selectedOption.value };
  }
  return undefined;
};

export const removeHash = () => {
  let scrollV;
  let scrollH;
  const loc = window.location;

  if ("pushState" in history) {
    history.pushState('', document.title, loc.pathname + loc.search);
  } else {
    // Prevent scrolling by storing the page's current scroll offset
    scrollV = document.body.scrollTop;
    scrollH = document.body.scrollLeft;

    loc.hash = '';

    // Restore the scroll offset, should be flicker free
    document.body.scrollTop = scrollV;
    document.body.scrollLeft = scrollH;
  }
};
